import { render, staticRenderFns } from "./TicketsPG.vue?vue&type=template&id=0f477dcb&"
import script from "./TicketsPG.vue?vue&type=script&lang=js&"
export * from "./TicketsPG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports